import { SalesIncentiveOpportunityModel } from 'outbound-api-client/lib/models';
import { apiService } from "../../services";

export const getOpportunities = async (campaignIdentifier: string | null, opportunityId: string | null): Promise<Array<SalesIncentiveOpportunityModel>> => {
   return await apiService.instance.getSalesIncentiveOpportunities(campaignIdentifier, opportunityId);
}
